export default __webpack_public_path__ + "static/media/jayme_blurb.30255616.png";